<template>
    <div class="view--basic">
        This displays some content for the view with key "info". ({{ tools.currentView.title }})
        <div v-if="tools.currentView.data.hasPane">Has pane!</div>
        {{ tools.randomizer.first() }}
        {{ tools.randomizer.last() }}

        <ui-button @click="() => this.tools.changeView()">Add breadcrumb</ui-button>

        <ui-button @click="() => this.tools.changeView({
            key: 'info',
            title: `Item #${Math.floor(Math.random() * 100)}`,
            data: {
                hasPane: true,
            }
            })">Add item with pane</ui-button>
        <ui-button @click="() => this.tools.changeView({
            key: 'basic-view',
            title: this.tools.randomizer.first(),
            data: {
                hasPane: false,
            }
            })">Add item without pane</ui-button>
    </div>
</template>

<script>
    export default {
        mounted() {
            console.log('Basic view mounted', this);
            console.log('randomizer', this.tools.randomizer);
            console.log('tools', this.tools);
        },
        name: 'view-basic',
        props: ['tools', 'viewKey'],
    };
</script>

<style>
    .view--basic {
        background-color: #f4f4f4;
        padding: 30px;
    }
</style>



// WEBPACK FOOTER //
// BasicView.vue?f53286f4